export const reviewerToContactKey = (reviewer)=>{
    var _reviewer_email;
    return ((_reviewer_email = reviewer.email) !== null && _reviewer_email !== void 0 ? _reviewer_email : '').toLowerCase();
};
export const contactToReviewer = (contact, isSignatory)=>({
        firstName: contact.firstName(),
        lastName: contact.lastName(),
        email: contact.email(),
        isSignatory,
        clientContactId: contact.id()
    });
export const eligibleForRow = (param)=>{
    let { clientContacts, primaryContact, reviewers, rowIndex } = param;
    const excludeEmails = new Set(reviewers.map((reviewer, index)=>index === rowIndex ? null : reviewer.email).filter((email)=>typeof email === 'string' && email.length > 0).map((email)=>email.toLowerCase()));
    return clientContacts.filter((contact)=>{
        if (primaryContact != null && contact.id() === primaryContact.id()) return false;
        if (excludeEmails.has(contact.email().toLowerCase())) return false;
        if (contact.isSample()) return false;
        return true;
    });
};
